import { render, staticRenderFns } from "./sponsorship_eligibility_co_signer.vue?vue&type=template&id=4caf7196&"
import script from "./sponsorship_eligibility_co_signer.vue?vue&type=script&lang=js&"
export * from "./sponsorship_eligibility_co_signer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports